export const PIXEL_TRACKING_TITLE = "Purchase Pixel Tracking";

export const PIXEL_TRACKING_KEYS = {
  PIXEL_ACESS_TOKEN: "fb_access_token",
  PIXEL_ID: "custom_pixel_token",
  GOOGLE_TRACKING_ID: "custom_ga_token",
  OVERIDE_ACCOUNT_LEVEL_GA_TOKEN: "is_override_google_token",
  OVERIDE_ACCOUNT_LEVEL_FB_TOKEN: "is_override_fb_token",
};
